import { SET_SESSION, CLEAR_SESSION } from '../actions/session';

const initialState = {
  expirationTime: null,
  state: null, // authenticated | anonymous | expired
};

export default function sessionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SESSION:
      return {
        ...state,
        expirationTime: action.payload.expirationTime ?? null,
        state: action.payload.state ?? null,
      };

    case CLEAR_SESSION:
      return {
        ...initialState, // reset everything cleanly
      };

    default:
      return state;
  }
}
